import PATH from "constants/path";
import React, { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated } from "utils/common";
import { getPromotion } from "features/Promotion/promotionSlice";
import { SERVICE } from "constants/global";
import Partner from "features/Promotion/components/Partner";
import DetailPromotion from "features/Promotion/components/DetailPromotion";
import ErrorDB from "components/ErrorDB";

const Promotion = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const pathname = useLocation().pathname;
  const { id } = useParams();

  const { promotion, promotion_set, isInLine } = useSelector((state) => state.promotion);

  const _PATH_ENTRIES = "entries";
  const pathURL = pathname.split("/")[1];
  const isTop = pathURL === _PATH_ENTRIES;
  // title
  let title =
    pathURL === _PATH_ENTRIES && isAuthenticated()
      ? "応募中案件"
      : "募集中の番組";
  // href back
  let hrefBack =
    pathURL === _PATH_ENTRIES && isAuthenticated() ? PATH.ENTRIES : PATH.TOP;
  // handle back page fit with path URL
  const handleBack = () => {
    history.push(hrefBack);
  };

  useEffect(() => {
    if (id) {
      dispatch(getPromotion({ service: SERVICE, id, isTop : !isTop }));
    }
  }, []);

  if (!promotion && !isInLine) return null;

  return (
    <div
      className={isAuthenticated() ? "w-80" : "container px-0 px-md-3 px-lg-0"}
    >
      {/* TITLE */}
      <div className="border-sticky border-news-no-top bg-f4 p-2 p-md-2 text-grey">
        <div className="position-relative text-center fs-14 fw-600">
          {title}
          <div
            onClick={handleBack}
            className="d-flex position-absolute start-0 top-0 cursor-pointer"
          >
            <i className="bi bi-chevron-left"></i>
            <span className="d-none d-md-block">戻る</span>
          </div>
        </div>
      </div>

      {
        isInLine ?
        <ErrorDB style={'mt-4'}/>
        :
        <div className="px-3 px-md-0">
          <DetailPromotion promotion={promotion} promotion_set={promotion_set} />

          {isAuthenticated() && !isTop ? (
            <Partner />
          ) : null}
        </div>
      }
    </div>
  );
};

export default Promotion;
